<div class="Modal">
  <div class="HeaderModal">
    <div class="IconModal float-start">
      <span class="material-icons">
        {{data.icon}}
      </span>
      <p>{{data.textIcon}}</p>
    </div>
    <span class="material-icons float-end CloseModal" [matDialogClose]="true"> close </span>
  </div>
  <div class="ModalContent">
    <h1 class="TtlModal text-center">
      {{data.title}}
    </h1>
    <p class="TxtModal text-center">
      {{data.text}}
    </p>

  </div>

  <div class="ModalContent">

    <div class="box-buttons d-flex justify-content-between">

      <button class="Btn BtnBorder" mat-dialog-close="true" [routerLink]="">{{data.firstBtnText}}</button>

    </div>
  </div>
</div>
